import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    withdraw: 'Withdraw',
    approve: 'Approve',
    inputTokenLabel: 'Amount {token}',
    period:
      'If you choose to undelegate, there is a {value}-{value, plural, =1 {day} other {days}} waiting period before the process completes.',
    gasFeeLabel: 'Gas fee',
    totalAmountLabel: 'Total staked',
  },
};
